import { css } from "styled-components";
import getProperty from "./getProperty";
import compatibleGridTemplate from "./compatibleGridTemplate";
import autoPlacement from "./autoPlacement";

var chooseGap = function chooseGap(specificGap, basicGap) {
  return specificGap && specificGap !== "0" ? specificGap : basicGap;
};

var getViewportIEGridStyles = function getViewportIEGridStyles(mediaQuery, childrenCount, _ref, props) {
  var index = _ref.index,
      devices = _ref.devices;
  var rows = getProperty("rows", {
    index: index,
    devices: devices
  }, props);
  var columns = getProperty("columns", {
    index: index,
    devices: devices
  }, props);
  var gap = getProperty("gap", {
    index: index,
    devices: devices
  }, props);
  var rowGap = chooseGap(getProperty("rowGap", {
    index: index,
    devices: devices
  }, props), gap);
  var columnGap = chooseGap(getProperty("columnGap", {
    index: index,
    devices: devices
  }, props), gap);
  var compatibleColumns = compatibleGridTemplate(columns, columnGap);
  var compatibleRows = compatibleGridTemplate(rows, rowGap);
  var childrenPlacement = autoPlacement(childrenCount, compatibleColumns, compatibleRows, columnGap, rowGap);
  return css(["-ms-grid-columns:", ";-ms-grid-rows:", ";", ";"], compatibleColumns, compatibleRows, childrenPlacement);
};

export default getViewportIEGridStyles;